/* SearchHeadingLegacy.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _4 = "._vwz4ahaf{line-height:2.25rem}";
const _3 = "._k48p1fw0{font-weight:700}";
const _2 = "._1mou1mhu{margin-block:var(--_1joasa1)}";
const _ = "._1mou1pyq{margin-block:var(--ds-space-100,8px) var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const H1 = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(H3, _objectSpread(_objectSpread({
    as: "h1"
  }, props), {}, {
    children: children
  }));
};
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H1,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1mou1pyq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const HeadingStyle = null;
const toCapitalCase = str => str.charAt(0).toUpperCase() + str.slice(1);
const getHeadingText = (isSearchOrFilter, productName) => {
  if (!productName) {
    return isSearchOrFilter ? 'Search results' : 'Search for apps';
  }
  const capitalizedProduct = toCapitalCase(productName);
  return isSearchOrFilter ? "Search results for ".concat(capitalizedProduct) : "Explore apps for ".concat(capitalizedProduct);
};
const SearchHeading = _ref3 => {
  let {
    isSearchQueryActive,
    areFiltersActive,
    productName
  } = _ref3;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isSearchOrFilter = isSearchQueryActive || areFiltersActive;
  const headingText = getHeadingText(isSearchOrFilter, productName);
  const useCoherence = enableMpacWebCoherence();
  if (useCoherence) {
    const HeadingComponent = productName ? H3 : H1;
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_2, _3, _4]
      }), /*#__PURE__*/_jsx(HeadingComponent, {
        as: "h1",
        className: ax(["_1mou1mhu _k48p1fw0 _vwz4ahaf"]),
        style: {
          "--_1joasa1": ix("var(--ds-space-negative-200, -16px)".concat(" ", "var(--ds-space-100, 8px)"))
        },
        children: headingText
      })]
    });
  }
  return /*#__PURE__*/_jsx(Heading, {
    children: headingText
  });
};
export default SearchHeading;